import { useState, useEffect, useRef } from "react";

// Lib
import MapToolMode from "lib/enums/maptoolmode";
import { Popup, PopupProps } from "lib/classes/popup";
import { assetURL } from "lib/utilities/asset";
import { addToArrayUnique, removeFromArray } from "lib/utilities/misc";
import { 
	toolModeNames, 
	getToolsEnabled, 
	getToolModeNames, 
	getToolDisabledOverride, 
	getInitialToolEnabled,
	setToolsMaster 
} from "lib/utilities/toolmodes";

// Lang
import { getLocaleString } from "lib/localization/vendor";

// Styling
import "styles/css/PermalinkPopup.scss";

var copyTimeout:any;
var copy2Timeout:any;

const PermalinkPopup = new Popup({
	title: () => getLocaleString("permalink"),
	style: {maxWidth: 540},
	distinct: true,
	render: function() {
		const mapConfig:any = this.get("opus-config");
		
		const [hash, setHash] = useState<string>(window.location.hash);
		const [copied, setCopied] = useState<boolean>(false);
		const [copied2, setCopied2] = useState<boolean>(false);
		const [toolModesEnabled, setToolModesEnabled] = useState<MapToolMode[]>(getToolsEnabled(mapConfig));
		
		const textRef = useRef(null);
		const embedTextRef = useRef(null);
		
		// Initialize
		useEffect(() => {
			window.addEventListener("hashchange", () => setHash(window.location.hash));
		}, []);
		
		useEffect(() => {
			setHash(window.location.hash);
		}, [window.location.hash]);
		
		const getLink = ():string => {
			return `${mapConfig.canonicalUrl}?siteid=${_config.UUID}${hash}`;
		}
		const getEmbedLink = ():string => {
			return `<iframe src="${getLink()}" width="720" height="480" style="border:none;"></iframe>`;
		}
		const copyLink = () => {
			textRef.current.select();
			document.execCommand("copy");
			
			setCopied(true);
			
			clearTimeout(copyTimeout);
			
			copyTimeout = setTimeout(() => {
				setCopied(false);
			}, 5000);
		}
		const copyEmbedLink = () => {
			embedTextRef.current.select();
			document.execCommand("copy");
			
			setCopied2(true);
			
			clearTimeout(copy2Timeout);
			
			copy2Timeout = setTimeout(() => {
				setCopied2(false);
			}, 5000);
		}
		
		const spacer = () => {
			return <div className="permalink__spacer"></div>
		}
		const drawMapToolModes = ():any => {
			const rows:any = [];
			
			toolModeNames.forEach((name:string, mode:MapToolMode) => rows.push(drawMapToolMode(name, mode)));
			
			return (
				<>
					<p><b>{getLocaleString("toolsenabled")}</b></p>
					{rows}
				</>
			)
		}
		const drawMapToolMode = (name:string, mode:MapToolMode):any => {
			const imagePath:string = `/assets/images/${name.replace("tool", "")}.png`;
			const checked:boolean = toolModesEnabled.indexOf(mode) > -1;
			
			if(getToolDisabledOverride(mode))
				return null;
			
			if(!getInitialToolEnabled(mode))
				return null;
				
			if((mode == MapToolMode.Draw || mode == MapToolMode.Upload) && !mapConfig.drawingTools?.panelEnabled)
				return null;
			
			const toggle = () => {
				const newModes:MapToolMode[] = [...toolModesEnabled];
				
				if(!checked)
					addToArrayUnique(mode, newModes);
				else
					removeFromArray(mode, newModes);
				
				setToolsMaster(getToolModeNames(newModes), true); // Update the hash as well (other way around to how this is called in ol-hashed/main.js)
				setToolModesEnabled(getToolsEnabled(mapConfig));
				setTimeout(() => setHash(window.location.hash), 100);
				
				_events.invoke('tool-modes-changed');
			}
			
			if(mode == MapToolMode.Draw)
				name = "drawsitetool";
			else
			if(mode == MapToolMode.Annotation)
				name = "annotate";
			
			return (
				<div className="permalink__maptoolmode" onClick={toggle} key={mode}>
					<input
						type="checkbox"
						checked={checked}
						onChange={toggle}
					/> 
					<img src={assetURL(imagePath)} /> 
					{getLocaleString(name)}
				</div>
			)
		}
		
		return (
			<div className="permalink">
				<div className="permalink__box" style={{marginBottom: 10}}>
					<div className="permalink__url">
						<input 
							type="text" 
							ref={textRef} 
							value={getLink()} 
							onClick={() => textRef.current.select()} 
							readOnly 
						/>
					</div>
					<div className="permalink__button">
						<button onClick={() => copyLink()}>
							{!copied ? getLocaleString("copy-link") : getLocaleString("copied")}
						</button>
					</div>
				</div>
				<div className="permalink__box">
					<div className="permalink__url">
						<input 
							type="text" 
							ref={embedTextRef} 
							value={getEmbedLink()} 
							onClick={() => embedTextRef.current.select()} 
							readOnly 
						/>
					</div>
					<div className="permalink__button">
						<button onClick={() => copyEmbedLink()}>
							{!copied2 ? getLocaleString("copy-embed") : getLocaleString("copied")}
						</button>
					</div>
				</div>
				
				{spacer()}
				{drawMapToolModes()}
				{spacer()}
				
				<p>{getLocaleString("permalinkinfo")}</p>
			</div>
		)
	}
});

export default PermalinkPopup;